export * from '@taqueria/protocol/out/types/MetadataConfig';
